






import { Component, Vue } from 'vue-property-decorator';
import JobForm from '@/components/job/JobForm.vue';
import { Action, Getter } from 'vuex-class';
import { Department } from '@/models/department.interface';
import { Country } from '../../models/country.interface';

@Component({
  components: {
    JobForm,
  },
})
export default class JobAdd extends Vue {
  @Action('getDepartmentsAction') public getDepartmentsAction!: () => void;
  @Action('getCountriesAction') public getCountriesAction!: () => void;
  @Action('resetJobWorkflowAction') public resetJobWorkflowAction!: () => void;
  @Getter public departments!: Department[];
  @Getter public countries!: Country[];
  @Getter public isDepartmentsFetched!: boolean;
  @Getter public isCountriesFetched!: boolean;

  public mounted(): void {
    !this.isDepartmentsFetched && this.getDepartmentsAction();
    !this.isCountriesFetched && this.getCountriesAction();
    this.resetJobWorkflowAction();
  }
}
